import {
	KristaDriverReportFinding,
	KristaGenerateResponse,
} from '../interfaces';

/**
 * Plain paragraphs for a finished Krista narrative.
 * Driver reports lead with the summary, then each finding, then the caveat.
 * Findings may still be the stored wire object (`statement`) or the app
 * model (`text`). Other products are one text block plus an optional caveat.
 */
export function insightNarrativeText(
	response: KristaGenerateResponse | null | undefined,
): string {
	if (!response) return '';

	if ('findings' in response && Array.isArray(response.findings)) {
		return joinParagraphs([
			tightenNarrative(response.text),
			...response.findings.map((finding) => findingText(finding)),
			response.caveat,
		]);
	}

	return joinParagraphs([tightenNarrative(response.text), response.caveat]);
}

function findingText(finding: KristaDriverReportFinding): string | undefined {
	const stored = finding as KristaDriverReportFinding & {
		statement?: string;
	};
	const text = stored.text ?? stored.statement;
	return typeof text === 'string' ? text : undefined;
}

/** Krista diagnostics arrive as one line joined by pipes. */
function tightenNarrative(text: string | undefined): string | undefined {
	if (!text?.includes(' | ')) return text;
	return text
		.split(/\s+\|\s+/)
		.map((part) => part.trim())
		.filter((part) => part.length > 0)
		.join('\n');
}

function joinParagraphs(parts: Array<string | null | undefined>): string {
	return parts
		.map((part) => part?.trim() ?? '')
		.filter((part) => part.length > 0)
		.join('\n\n');
}
